import { render, staticRenderFns } from "./camera-coordinate-input.vue?vue&type=template&id=3c56b2fa&"
import script from "./camera-coordinate-input.vue?vue&type=script&lang=js&"
export * from "./camera-coordinate-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports